module.exports = __webpack_public_path__ + "static/media/icon_newspapers_other_papers.699547e7.svg";